module.exports = __webpack_public_path__ + "img/894480a22d67a46a9b8b6a256f9af6e9.827b77e4.jpg";